/*
 * Theaterish cart — self-contained Ajax cart on Shopify's Cart API + Section
 * Rendering. Handles: add-to-cart (forms with [data-th-cart-add]), quantity
 * steppers and remove inside [data-th-cart-contents], the slide-in drawer, the
 * header count bubble, the cart page, and a toast. No dependency on the theme's
 * own cart machinery.
 */
(function () {
  var DRAWER_SECTION = 'theaterish-cart-drawer';
  var PAGE_SECTION = 'theaterish-cart';
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Drawer open/close ---------- */
  function drawer() { return $('#ThCartDrawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.hidden = false;
    // allow the browser to paint `hidden=false` before transitioning
    requestAnimationFrame(function () {
      d.classList.add('is-open');
      document.documentElement.classList.add('th-cart-lock');
    });
    var close = $('[data-th-drawer-close]', d);
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('th-cart-lock');
    var onEnd = function () { d.hidden = true; d.removeEventListener('transitionend', onEnd); };
    d.addEventListener('transitionend', onEnd);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#ThToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  /* ---------- Count bubble ---------- */
  function updateCount(count) {
    $all('.cart-link__bubble').forEach(function (el) { el.textContent = count; });
    $all('.th-cart-link').forEach(function (el) { el.classList.toggle('is-filled', count > 0); });
  }

  /* ---------- Apply re-rendered sections ---------- */
  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc;
  }

  function applySections(sections) {
    if (!sections) return;

    if (sections[DRAWER_SECTION] != null) {
      var newDrawer = $('[data-th-cart-contents]', parse(sections[DRAWER_SECTION]));
      var liveDrawer = $('#ThCartDrawer [data-th-cart-contents]');
      if (newDrawer && liveDrawer) {
        liveDrawer.replaceWith(newDrawer);
        var c = newDrawer.getAttribute('data-cart-count');
        if (c != null) updateCount(parseInt(c, 10) || 0);
      }
    }

    if (sections[PAGE_SECTION] != null) {
      var newPage = $('[data-th-cart-page]', parse(sections[PAGE_SECTION]));
      var livePage = $('[data-th-cart-page]');
      if (newPage && livePage) livePage.innerHTML = newPage.innerHTML;
    }
  }

  function requestedSections() {
    var list = [DRAWER_SECTION];
    if ($('[data-th-cart-page]')) list.push(PAGE_SECTION);
    return list;
  }

  /* ---------- Cart API ---------- */
  function post(url, body) {
    return fetch(routeRoot + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
  }

  function addToCart(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var payload = {
      id: idInput.value,
      quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
      sections: requestedSections().join(','),
      sections_url: window.location.pathname
    };
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    post('cart/add.js', payload).then(function (res) {
      if (btn) btn.removeAttribute('aria-busy');
      if (!res.ok) {
        toast((res.data && res.data.description) || 'Could not add to cart');
        return;
      }
      applySections(res.data.sections);
      var title = res.data.product_title || (res.data.items && res.data.items[0] && res.data.items[0].product_title) || 'Item';
      toast('Added “' + title + '” to cart');
      openDrawer();
    }).catch(function () {
      if (btn) btn.removeAttribute('aria-busy');
      toast('Could not add to cart');
    });
  }

  function changeLine(key, quantity) {
    return post('cart/change.js', {
      id: key,
      quantity: quantity,
      sections: requestedSections().join(','),
      sections_url: window.location.pathname
    }).then(function (res) {
      if (res.ok) applySections(res.data.sections);
    });
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-th-cart-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', function (e) {
    // Open drawer from the header cart button
    var toggle = e.target.closest('[data-th-cart-toggle]');
    if (toggle) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-th-drawer-close]')) { closeDrawer(); return; }
    if (e.target.closest('[data-th-drawer-overlay]')) { closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-th-qty]');
    if (qtyBtn) {
      var item = qtyBtn.closest('[data-key]');
      if (!item) return;
      var val = parseInt($('[data-th-qty-val]', item).textContent, 10) || 1;
      var next = qtyBtn.getAttribute('data-th-qty') === 'inc' ? val + 1 : val - 1;
      changeLine(item.getAttribute('data-key'), Math.max(0, next));
      return;
    }

    var remove = e.target.closest('[data-th-remove]');
    if (remove) {
      var li = remove.closest('[data-key]');
      if (li) changeLine(li.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
